<script>
	import { createEventDispatcher } from 'svelte'
	import ThinButton from '../../../components/ThinButton/ThinButton.svelte'
	import ActionButton from '../../../components/ActionButton/ActionButton.svelte'
	import Dialog from '../../../components/Modal/Dialog.svelte'
	import LogDetailPanel from './LogDetailPanel.svelte'

	export let time
	export let name
	export let id
	export let grandtotal = false
	export let editing = false
	export let log

	let editing_busy = false,
		deleteDialog = false,
		confirmDisabled = false,
		time_internal = time

	const dispatch = createEventDispatcher()

	const onEditStart = (event) => {
		editing = true
	}

	const onTimeDown = () => {
		time_internal = time_internal > 0 ? time_internal - 0.25 : 0
	}

	const onTimeUp = () => {
		time_internal = time_internal < 11 ? time_internal + 0.25 : 11
	}

	const onEditCancel = () => {
		time_internal = time
		editing = false
		if (log && log.blank) dispatch('creation-canceled')
	}

	const onEditComplete = (event) => {
		editing_busy = true
		if (log && log.blank) {
			delete log.blank
			dispatch('create', {
				user: log.user.id,
				time: time_internal,
				resolver: () => {
					editing_busy = false
					editing = false
				}
			})
		} else {
			dispatch('update', {
				id,
				time: time_internal,
				resolver: () => {
					editing_busy = false
					editing = false
				}
			})
		}
	}

	const onOperatorSelect = (event) => {
		const { token_id, name: username } = event.detail
		if (log) {
			log.user.id = token_id
			log.user.name = username
			name = username
		}
	}

	const deleteItem = (event) => {
		event.stopPropagation()
		deleteDialog = true
	}

	const cancelDelete = (event) => {
		deleteDialog = false
	}

	const confirmDelete = (event) => {
		deleteDialog = false
		dispatch('delete', { id })
	}

	const loadTimeValue = () => {
		time_internal = time
	}

	const logUpdate = () => {
		if (log && log.blank) {
			confirmDisabled = log.user && log.user.id ? false : true
		}
	}

	$: logUpdate(log)
	$: loadTimeValue(time)
</script>

<div class="sub-log-item clearfix" class:editing class:grandtotal>
	<div class="hours">{time_internal}</div>
	{#if editing}
		{#if log && log.blank}
			<div class="name">{name}</div>
		{/if}
		<ActionButton icon="far fa-minus" on:click={onTimeDown} />
		<ActionButton icon="far fa-plus" on:click={onTimeUp} />
		<ActionButton icon="far fa-times" danger on:click={onEditCancel} />
		<ActionButton
			icon="far fa-check"
			disabled={confirmDisabled}
			success
			busy={editing_busy}
			on:click={onEditComplete}
		/>
	{:else}
		<div class="name">{name}</div>
	{/if}
	{#if grandtotal === false}
		<div class="ctrls">
			<ThinButton label="Modifica" on:click={onEditStart} />
			<ThinButton label="Elimina" on:click={deleteItem} />
		</div>
	{/if}
	{#if log && log.blank}
		<LogDetailPanel on:operator-select={onOperatorSelect} />
	{/if}
</div>

{#if deleteDialog}
	<Dialog title="Vuoi davvero eliminare questo log?" on:cancel={cancelDelete} on:confirm={confirmDelete} leftAlign>
		<div class="dialog-meta">
			<div class="lbl">{time_internal}ore @ {name}</div>
		</div>
	</Dialog>
{/if}

<style>
	.sub-log-item {
		background-color: #f4f8fb;
		border-radius: 2px;
		/* padding: 5px; */
		margin-top: 5px;
		position: relative;
		display: flex;
		align-items: center;
	}
	.sub-log-item.grandtotal {
		background-color: #d9eeff;
	}
	.sub-log-item.editing {
		padding: 10px 0;
		background-color: #fdfbdd;
	}
	.sub-log-item .hours {
		float: left;
		width: 40px;
		text-align: center;
		font-weight: 600;
	}
	.sub-log-item .name {
		float: left;
		margin-right: 10px;
	}
	.sub-log-item :global(.ActionButton) {
		margin-right: 3px;
	}
	.sub-log-item.editing .hours {
		line-height: 30px;
	}
	.sub-log-item .ctrls {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		text-align: right;
		padding: 0 5px;
		display: none;
	}
	.sub-log-item:hover .ctrls {
		display: block;
	}
	.sub-log-item.editing:hover .ctrls {
		display: none;
	}
</style>
